import { useEffect, useState } from 'react';
import { fetcher } from 'src/config/request';
function addTokenToRequestHeaders(token) {
    fetcher.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
export function useAuth(params) {
    const [user, setUser] = useState();
    useEffect(function effectSetWithHostValues() {
        setUser(params.user);
        if (params.token) {
            addTokenToRequestHeaders(params.token);
        }
    }, [params.token, params.user]);
    useEffect(function effectLogin() {
        if (process.env.CAS_ENABLED === 'true') {
            import('src/core/services/auth').then((module) => {
                const AuthService = module.AuthService;
                AuthService.subscribe((authUser) => {
                    const user = {
                        id: authUser.profile.id ?? '',
                        token: authUser.id_token ?? '',
                        name: authUser.profile.name ?? '',
                        email: authUser.profile.email ?? '',
                        ucode: authUser.profile.ucode ?? '',
                        sessionId: authUser.profile.sid ?? '',
                        authorities: authUser.profile.authorities ?? []
                    };
                    setUser(user);
                    addTokenToRequestHeaders(authUser.access_token);
                });
                AuthService.start();
            });
        }
    }, []);
    return { user, isAuthenticating: !user };
}
